<div class="form-container-large">
  <!-- Header com título -->
  <div class="title-box">
    <h1 class="title-primary">Gerenciamento de Pagamentos</h1>
    <p class="title-primary-description">Gerencie pagamentos, parcelas e planos de acesso</p>
  </div>

  <!-- SEÇÃO DE FILTROS -->
  <div class="card" style="margin-bottom: var(--spacing-lg);">
    <div class="card-header">
      <h2 class="card-title">
        <mat-icon style="vertical-align: middle; margin-right: 8px;">filter_list</mat-icon>
        Filtros de Busca
      </h2>
    </div>
    <div class="card-body">
      <div class="row-2-col">
        <mat-form-field appearance="outline" floatLabel="always">
          <mat-label>CPF/CNPJ</mat-label>
          <input matInput [(ngModel)]="filterCpfCnpj" placeholder="Digite o CPF ou CNPJ">
          <mat-icon matSuffix>search</mat-icon>
        </mat-form-field>

        <mat-form-field appearance="outline" floatLabel="always">
          <mat-label>Status</mat-label>
          <mat-select [(ngModel)]="filterStatus">
            <mat-option value="">Todos</mat-option>
            <mat-option *ngFor="let status of paymentStatus" [value]="status">
              {{ status | enumDescription }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>

      <div class="row" style="margin-bottom: var(--spacing-md);">
        <mat-checkbox [(ngModel)]="showOnlyOverdue">
          Mostrar apenas em atraso
        </mat-checkbox>
      </div>

      <div class="buttons-wrap">
        <button mat-flat-button color="primary" (click)="applyFilters()" class="btn btn-primary">
          <mat-icon>search</mat-icon>
          Aplicar Filtros
        </button>
        <button mat-stroked-button (click)="clearFilters()" class="btn btn-ghost">
          <mat-icon>clear</mat-icon>
          Limpar
        </button>
      </div>
    </div>
  </div>

  <!-- SEÇÃO DE CRIAÇÃO DE PAGAMENTO -->
  <div class="card" style="margin-bottom: var(--spacing-lg);">
    <div class="card-header">
      <h2 class="card-title">
        <mat-icon style="vertical-align: middle; margin-right: 8px;">add_circle</mat-icon>
        Criar Novo Pagamento
      </h2>
    </div>
    <div class="card-body">
      <form [formGroup]="createPaymentForm">
        <div class="row-2-col">
          <mat-form-field appearance="outline" floatLabel="always">
            <mat-label>Plano</mat-label>
            <mat-select formControlName="accessPlanId" required>
              <mat-option *ngFor="let plan of accessPlans" [value]="plan.id">
                Plano #{{ plan.id }} - {{ formatCpfCnpj(plan.cpfcnpj) }}
              </mat-option>
            </mat-select>
            <mat-error>Campo obrigatório</mat-error>
          </mat-form-field>

          <mat-form-field appearance="outline" floatLabel="always">
            <mat-label>Número de Parcelas</mat-label>
            <input matInput type="number" formControlName="numberOfInstallments" min="1" max="12" required>
            <mat-error>Entre 1 e 12 parcelas</mat-error>
          </mat-form-field>
        </div>

        <div class="row-2-col">
          <mat-form-field appearance="outline" floatLabel="always">
            <mat-label>Método de Pagamento</mat-label>
            <mat-select formControlName="method" required>
              <mat-option *ngFor="let method of paymentMethods" [value]="method">
                {{ method | enumDescription }}
              </mat-option>
            </mat-select>
            <mat-error>Campo obrigatório</mat-error>
          </mat-form-field>
        </div>

        <div class="buttons-wrap">
          <button mat-flat-button color="primary" (click)="createPaymentWithInstallments()"
            [disabled]="createPaymentForm.invalid" class="btn btn-primary">
            <mat-icon>save</mat-icon>
            Criar Pagamento
          </button>
          <button mat-stroked-button type="button" (click)="resetCreatePaymentForm()" class="btn btn-ghost">
            <mat-icon>refresh</mat-icon>
            Limpar
          </button>
        </div>
      </form>
    </div>
  </div>

  <!-- TABELA DE PAGAMENTOS -->
  <div class="card">
    <div class="card-header">
      <h2 class="card-title">
        <mat-icon style="vertical-align: middle; margin-right: 8px;">receipt_long</mat-icon>
        Lista de Pagamentos
      </h2>
    </div>
    <div class="card-body">
      <div class="table-container">
        <table mat-table [dataSource]="dataSource" class="mat-elevation-z2">
          <!-- ID Column -->
          <ng-container matColumnDef="id">
            <th mat-header-cell *matHeaderCellDef>ID</th>
            <td mat-cell *matCellDef="let payment">#{{ payment.id }}</td>
          </ng-container>

          <!-- Access Plan Column -->
          <ng-container matColumnDef="accessPlanId">
            <th mat-header-cell *matHeaderCellDef>Plano</th>
            <td mat-cell *matCellDef="let payment">{{ getPlanName(payment.accessPlanId) }}</td>
          </ng-container>

          <!-- Total Amount Column -->
          <ng-container matColumnDef="totalAmount">
            <th mat-header-cell *matHeaderCellDef>Valor Total</th>
            <td mat-cell *matCellDef="let payment">{{ formatPrice(payment.totalAmount) }}</td>
          </ng-container>

          <!-- Method Column -->
          <ng-container matColumnDef="method">
            <th mat-header-cell *matHeaderCellDef>Método</th>
            <td mat-cell *matCellDef="let payment">
              {{ payment.method | enumDescription }}
            </td>
          </ng-container>

          <!-- Status Column -->
          <ng-container matColumnDef="status">
            <th mat-header-cell *matHeaderCellDef>Status</th>
            <td mat-cell *matCellDef="let payment">
              <span class="badge" [ngClass]="{
                  'badge-warning': payment.status === 'PENDING_PAYMENT' || payment.status === 'FAILED',
                  'badge-success': payment.status === 'PAID',
                  'badge-primary': payment.status === 'PARTIALLY_PAID'
                }">
                {{ payment.status | enumDescription }}
              </span>
            </td>
          </ng-container>

          <!-- Actions Column -->
          <ng-container matColumnDef="actions">
            <th mat-header-cell *matHeaderCellDef class="col-actions">Ações</th>
            <td mat-cell *matCellDef="let payment" class="col-actions">
              <button mat-icon-button [matMenuTriggerFor]="menu" color="primary">
                <mat-icon>more_vert</mat-icon>
              </button>
              <mat-menu #menu="matMenu">
                <button mat-menu-item (click)="openPaymentDetailsDialog(payment)">
                  <mat-icon>info</mat-icon>
                  <span>Detalhes</span>
                </button>
                <button mat-menu-item (click)="editPayment(payment)">
                  <mat-icon>edit</mat-icon>
                  <span>Editar</span>
                </button>
                <button mat-menu-item (click)="deletePayment(payment.id!)">
                  <mat-icon color="warn">delete</mat-icon>
                  <span>Excluir</span>
                </button>
              </mat-menu>
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

          <tr class="mat-row" *matNoDataRow>
            <td class="mat-cell" [attr.colspan]="displayedColumns.length" style="text-align: center; padding: var(--spacing-xl);">
              <div style="display: flex; flex-direction: column; align-items: center; gap: var(--spacing-md);">
                <mat-icon style="font-size: 48px; width: 48px; height: 48px; color: var(--color-text-muted);">
                  inbox
                </mat-icon>
                <span style="color: var(--color-text-secondary);">Nenhum pagamento encontrado</span>
              </div>
            </td>
          </tr>
        </table>
      </div>
    </div>
  </div>

  <!-- DETALHES DO PAGAMENTO E PARCELAS -->
  <div *ngIf="selectedPayment" class="card" style="margin-top: var(--spacing-lg);">
    <div class="card-header" style="display: flex; justify-content: space-between; align-items: center;">
      <h2 class="card-title">
        <mat-icon style="vertical-align: middle; margin-right: 8px;">info</mat-icon>
        Detalhes do Pagamento #{{ selectedPayment.id }}
      </h2>
      <button mat-icon-button (click)="closePaymentDetails()" color="warn">
        <mat-icon>close</mat-icon>
      </button>
    </div>

    <div class="card-body">
      <!-- Informações do Pagamento -->
      <h3 class="title-section">Informações do Pagamento</h3>
      <div style="display: grid; grid-template-columns: repeat(auto-fit, minmax(200px, 1fr)); gap: var(--spacing-md); margin-bottom: var(--spacing-lg);">
        <div class="info-card">
          <span class="info-label">Valor Total:</span>
          <span class="info-value">{{ formatPrice(selectedPayment.totalAmount) }}</span>
        </div>
        <div class="info-card">
          <span class="info-label">Valor Pago:</span>
          <span class="info-value">{{ formatPrice(getTotalPaid(selectedPayment)) }}</span>
        </div>
        <div class="info-card">
          <span class="info-label">Método:</span>
          <span class="info-value">{{ selectedPayment.method! | enumDescription }}</span>
        </div>
        <div class="info-card">
          <span class="info-label">Status:</span>
          <span class="badge" [ngClass]="{
              'badge-warning': selectedPayment.status === 'PENDING_PAYMENT' || selectedPayment.status === 'FAILED',
              'badge-success': selectedPayment.status === 'PAID',
              'badge-primary': selectedPayment.status === 'PARTIALLY_PAID'
            }">
            {{ selectedPayment.status! | enumDescription }}
          </span>
        </div>
      </div>

      <!-- Informações do Plano -->
      <h3 class="title-section">Plano Relacionado</h3>
      <div style="margin-bottom: var(--spacing-lg);">
        <div class="info-card">
          <span class="info-label">ID do Plano:</span>
          <span class="info-value">{{ getPlanName(selectedPayment.accessPlanId) }}</span>
        </div>
      </div>

      <!-- Parcelas -->
      <h3 class="title-section">Parcelas</h3>
      <div class="table-container">
        <table mat-table [dataSource]="selectedInstallments" class="mat-elevation-z1">
          <!-- Installment Number Column -->
          <ng-container matColumnDef="installmentNumber">
            <th mat-header-cell *matHeaderCellDef>Parcela</th>
            <td mat-cell *matCellDef="let installment">
              <strong>{{ installment.installmentNumber }}</strong>
            </td>
          </ng-container>

          <!-- Amount Column -->
          <ng-container matColumnDef="amount">
            <th mat-header-cell *matHeaderCellDef>Valor</th>
            <td mat-cell *matCellDef="let installment">
              {{ formatPrice(installment.amount) }}
            </td>
          </ng-container>

          <!-- Due Date Column -->
          <ng-container matColumnDef="dueDate">
            <th mat-header-cell *matHeaderCellDef>Vencimento</th>
            <td mat-cell *matCellDef="let installment">
              {{ formatDate(installment.dueDate) }}
            </td>
          </ng-container>

          <!-- Paid At Column -->
          <ng-container matColumnDef="paidAt">
            <th mat-header-cell *matHeaderCellDef>Pago em</th>
            <td mat-cell *matCellDef="let installment">
              {{ formatDateTime(installment.paidAt ?? undefined) }}
            </td>
          </ng-container>

          <!-- Status Column -->
          <ng-container matColumnDef="status">
            <th mat-header-cell *matHeaderCellDef>Status</th>
            <td mat-cell *matCellDef="let installment">
              <span class="badge" [ngClass]="{
                  'badge-warning': installment.status === 'PENDING_PAYMENT' || installment.status === 'LATE',
                  'badge-success': installment.status === 'PAID',
                  'badge-cancelled': installment.status === 'CANCELLED_PAYMENT'
                }">
                {{ installment.status | enumDescription }}
              </span>
            </td>
          </ng-container>

          <!-- Actions Column -->
          <ng-container matColumnDef="actions">
            <th mat-header-cell *matHeaderCellDef class="col-actions">Ações</th>
            <td mat-cell *matCellDef="let installment" class="col-actions">
              <button mat-icon-button *ngIf="canPayInstallment(installment)" 
                (click)="payInstallment(installment.id!)"
                color="primary" 
                matTooltip="Pagar Parcela">
                <mat-icon>payment</mat-icon>
              </button>
              <button mat-icon-button *ngIf="canCancelInstallment(installment)"
                (click)="cancelInstallment(installment.id!)" 
                color="warn" 
                matTooltip="Cancelar Parcela">
                <mat-icon>cancel</mat-icon>
              </button>
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedInstallmentColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedInstallmentColumns;"></tr>

          <tr class="mat-row" *matNoDataRow>
            <td class="mat-cell" [attr.colspan]="displayedInstallmentColumns.length" style="text-align: center; padding: var(--spacing-xl);">
              <div style="display: flex; flex-direction: column; align-items: center; gap: var(--spacing-md);">
                <mat-icon style="font-size: 48px; width: 48px; height: 48px; color: var(--color-text-muted);">
                  receipt
                </mat-icon>
                <span style="color: var(--color-text-secondary);">Nenhuma parcela encontrada</span>
              </div>
            </td>
          </tr>
        </table>
      </div>
    </div>
  </div>
</div>